export const jobDescriptionContent = `
## About Studio Atelico

At Studio Atelico, we craft AI games and technologies that push the boundaries of conventional gameplay, creating new genres that captivate and surprise players in profound ways.

We’re here to redefine interactive entertainment with AI, unlocking unprecedented creativity and creating deeply immersive gaming experiences that inspire curiosity, connection, and wonder. We celebrate every player’s imagination and fuel every developer’s vision.

Our core values are: 
- Craftsmanship
- Playfulness
- Pioneering
- By Humans, For Humans

## 

## Job Description

We seek a hands-on, accomplished art director who thrives in a fast-paced environment. You will help define the artistic vision of our games and be the go-to expert and owner on all things art in our games, able to pivot from UI/UX design to concept art to production-ready assets. You take pride in your work and are also self-aware enough to know when to consult your rolodex to get optimal results. 

## Responsibilities 

* Define and drive the artistic vision for our games, ensuring a high-quality, cohesive and engaging visual experience.  
* Define and deliver the pipeline to accomplish the above that may involve contractors and freelancers.  
* Work harmoniously with game design, engineering and the rest of the company.  
* Work with the development team to integrate art assets in-engine and create a world-class game experience.  
* Help shape our strategy on art creation to engage with artists in an ethical way in a post-generative AI world.  
* Analyze feedback from multiple sources to inform evolutions of visual direction.  
* Think strategically about art and how it informs and enhances the player experience.   
* Assure that game information is well-conveyed through the various user interfaces.  
* Produce art assets as needed for marketing and other business needs.

## Requirements

* 8+ years experience in the video game industry.  
* T-shaped skillset, with broad art knowledge and deep expertise in at least one area, and strong adaptability to new styles and techniques.  
* Excellent graphic design skill in 2D art production.  
* Strong problem-solving skills, with the ability to balance technical constraints and artistic goals.  
* Experience defining and shipping a product-level vision.  
* Strong understanding of art fundamentals, multiple art styles, anatomy, appeal, and storytelling.  
* Experience with effective feedback for outsourcing and contractors.  
* Proficient in industry-standard software such as Adobe Creative Suite, Maya, 3ds Max, or equivalent.  
* Strong understanding of game development processes and limitations.  
* Strong organizational and project management skills.  
* Passionate about gaming, exceptional communication skills, collaborative team approach, and ability to handle pressure.  
* An eye for quality, consistency, and attention to detail.  
* A start-up mentality: comfortable wearing many hats, prioritizing their work autonomously and getting things done.

## Bonus Qualifications

* Experience as a product-level Art Director in a game studio with a deep understanding of different art disciplines and their workflows.  
* Strong understanding of UI/UX design, including sketching, wire framing and storyboarding abilities on paper and screen.  
* An understanding of the full pipeline for getting UI assets into game.  
* Solid understanding of 2d art import and integration Best Practices within a 2d mobile application.  
* Passionate about learning and applying cutting edge AI research  
* Understanding and experience with LLM prompt engineering  
* Experience with Git  
* Experience shipping in Godot Engine  
* Experience with 3D asset generation and optimization


## Interested in applying? [Hit us up!](mailto:hello@atelico.studio)
`;

export default jobDescriptionContent;
